import { lazy, Suspense, ComponentType, LazyExoticComponent } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";

function lazyWithRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>
): LazyExoticComponent<T> {
  return lazy(() =>
    factory().catch(() => {
      return import("@/pages/NotFound").then((m) => ({
        default: m.default as unknown as T,
      }));
    })
  );
}

function PageLoading() {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="w-8 h-8 border-3 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}

const LazyCategoryPage = lazyWithRetry(() => import("@/pages/category/page"));
const LazyArticlePage = lazyWithRetry(() => import("@/pages/article/page"));
const LazyAboutPage = lazyWithRetry(() => import("@/pages/about/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:slug",
    element: (
      <Suspense fallback={<PageLoading />}>
        <LazyCategoryPage />
      </Suspense>
    ),
  },
  {
    path: "/article/:slug",
    element: (
      <Suspense fallback={<PageLoading />}>
        <LazyArticlePage />
      </Suspense>
    ),
  },
  {
    path: "/about",
    element: (
      <Suspense fallback={<PageLoading />}>
        <LazyAboutPage />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;